"use client";

import { categoriesGet } from "@/action/category";
import { TiShoppingCart } from "react-icons/ti";
import { ArticleType } from "@/types/article";
import { categoryType } from "@/types/categories";
import { GiHandTruck } from "react-icons/gi";
import { useActionState, useEffect, useState } from "react";
import { FaNotesMedical } from "react-icons/fa";
import { BiSearch } from "react-icons/bi";

import { MdCancel } from "react-icons/md";
import { ReserveArticle } from "@/types/reserveArticle";
import { localCart } from "@/action/localCart";
import { ToastContainer, toast } from "react-toastify";
import CartContainer from "./cart_container";

import { useRouter } from "next/navigation";
import { getArticles } from "@/action/article";
import ListMedSchema from "@/app/[locale]/dash/components/list_med_schema";
import { IoCloseCircle, IoFilterSharp } from "react-icons/io5";
import MyImage from "@/components/image_layout/my_image";

export default function ListMedecinTab() {
  const [categories, setCategories] = useState<categoryType[]>([]);

  const [listLoading, setListLoading] = useState(true);
  const [articleList, setArticleList] = useState<ArticleType[]>([]);

  const [artico, setArtico] = useState<ArticleType>();
  const [modalCmd, setModalCmd] = useState(false);
  const [validCheck, setValidCheck] = useState(false);

  const [state, action, isPending] = useActionState(localCart, undefined);

  const [items, setItems] = useState<ReserveArticle[]>([]);

  const [showCart, setShowCart] = useState(false);
  const [showCatMobile, setShowCatMobile] = useState(false);
  const [catFilter, setCatFilter] = useState<categoryType>();

  const [selectedCategory, setSelectedCategory] = useState<string>("all");
  const [search, setSearch] = useState<string>("");

  const [seeSearch, setSeeSearch] = useState(false);

  const router = useRouter();

  const notify = () =>
    toast.success("Ajouter dans la list de commande avec succée!");

  useEffect(() => {
    const loadCategories = async () => {
      // const authUser = await getAuthUser();
      // const user = authUser?.user as UserType;

      setListLoading(true);

      try {
        const categories = await categoriesGet();
        const categoriesTab = categories?.categories;
        // console.log("--++__++:: ", categoriesTab);
        setCategories(categoriesTab);

        const arts = await getArticles();
        console.log("ARTICLES :-:-: \\\\\\ ", arts);
        setArticleList(arts?.articles);

        const existing = JSON.parse(localStorage.getItem("cart") || "[]");
        setItems(existing);
      } catch (error) {
        console.error(error);
      } finally {
        setListLoading(false); // ✅ always runs
      }
    };
    loadCategories();
  }, []);

  // Load from localStorage on mount
  useEffect(() => {
    const loadLocalCart = async () => {
      if (state?.success && state?.data) {
        const existing = JSON.parse(localStorage.getItem("cart") || "[]");
        const updated = [...existing, state.data];
        const cleanTab = updated.filter(
          (item, index, self) =>
            index ===
            self.map((obj) => obj.designation).lastIndexOf(item.designation)
        );

        localStorage.setItem("cart", JSON.stringify(cleanTab));
        console.log("Cart saved to localStorage:", cleanTab);
        setItems(cleanTab);
        notify();
        setModalCmd(false);
        router.refresh();
      }
    };

    loadLocalCart();
  }, [state]);

  // Load from localStorage on mount
  useEffect(() => {
    const loadLocalCart = async () => {
      const existing = JSON.parse(localStorage.getItem("cart") || "[]");

      setItems(existing);
    };

    loadLocalCart();
  }, [items.length]);

  // console.log(categories, " <---- CATEGORIES");
  // console.log(articleList, " <---- ARTICLES");

  // useEffect(() => {
  //   console.log(catFilter, " <--- FILTER CAT");
  // }, [catFilter]);

  const handleCategoryFilter = (cat: categoryType) => {
    if (cat) setCatFilter(cat);
  };

  function handleComdClick(data: ArticleType) {
    if (!data) {
      return;
    }
    setArtico(data);
    setModalCmd(true);
  }
  <ListMobileCategories
    listLoading={listLoading}
    categories={categories}
    handleCategoryFilter={handleCategoryFilter}
  />;

  let lastCartItem = [] as ReserveArticle | any;

  if (items) {
    lastCartItem = items[items.length - 1] as ReserveArticle;
  }

  // const filteredArticles =
  //   selectedCategory === "all"
  //     ? articleList
  //     : articleList?.filter((article) => article.theCode == selectedCategory);

  const filteredArticles = articleList?.filter((article) => {
    const matchesCategory =
      selectedCategory === "all" || article.theCode === selectedCategory;

    const matchesSearch =
      article.libele.toLowerCase().includes(search.toLowerCase()) ||
      article.theCode.toLowerCase().includes(search.toLowerCase());

    return matchesCategory && matchesSearch;
  });

  return (
    <div className="relative  flex  gap-4   h-[50vh]    w-full  ">
      <ToastContainer />

      <CartContainer
        modalCart={showCart}
        clickOutside={(e: any) => {
          if (e.target == e.currentTarget) setShowCart(false);
        }}
      />
      

      {/* CART BTN */}
      {items?.length > 0 && (
        <div
          onClick={() => setShowCart(true)}
          className="fixed flex flex-col gap-2 
      justify-center items-center z-50 bottom-10 right-10  "
        >
          <div className="h-14 w-14 border border-[#009900] flex justify-center items-center rounded-full transition-all duration-300 cursor-pointer lg:h-18 lg:w-18 hover:scale-102">
            <div className="bg-[#009900] flex flex-col gap-1 justify-center items-center  h-12 w-12 rounded-full  text-white lg:h-15 lg:w-15 ">
              <FaNotesMedical className=" text-xl lg:text-3xl" />
            </div>
          </div>
          <p className="text-sm text-[#009900] text-center ">List commande</p>
          <div className="h-7 w-7 border-2 border-white rounded-full bg-red-400 text-white flex justify-center items-center absolute right-0 top-0 ">
            {items?.length}
          </div>
        </div>
      )}
      {/* //? MODAL CMD */}
      <div
        onClick={(e) => {
          if (e.target == e.currentTarget) {
            setModalCmd(false);
          }
        }}
        className={` transition-all duration-300 backdrop-blur-[2px] min-h-[100vh] flex items-end pb-5 justify-center z-90 fixed top-0 left-0 overflow-scroll  w-full bg-[#111]/30 ${
          modalCmd
            ? " pointer-events-auto opacity-100  "
            : " opacity-0 pointer-events-none  "
        } `}
      >
        <div
          className={`w-[95vw] min-h-[70vh] pb-4 relative bg-white overflow-hidden  transition-all rounded-md duration-300 md:w-[65vw] lg:w-[35vw] xl:w-[25vw]  ${
            modalCmd ? "translate-y-0  " : " -translate-y-52  "
          } `}
        >
          {/* header */}
          <div className=" p-2 px-4 font-bold text-white text-xl bg-gradient-to-tr from-[#009900]  to-[#edf04f] ">
            Reservation
          </div>
          {/* CONTENT */}
          <div className=" py-1 px-4 ">
            <div className="text-[#111] border border-[#9d9d9d] rounded-md font-semibold mt-2 text-xl px-4 py-2 ">
              {artico?.libele}
            </div>

            <form
              id="formCart"
              action={action}
              className="py-2 flex flex-col overflow-y-scroll h-[50vh] pb-4 md:h-[70vh]  "
            >
              <div className="w-full text-sm mt-2 flex flex-col gap-1 md:text-base">
                <label htmlFor="designation">Designation</label>
                <input
                  type="text"
                  name="designation"
                  id="designation"
                  defaultValue={artico?.libele ?? ""}
                  required
                  placeholder="Designation"
                  className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                       border-[#9d9d9d]
                  `}
                />
              </div>
              <div className="text-sm flex gap-4 w-full md:text-base ">
                <div className="w-full mt-2 flex flex-col gap-1">
                  <label htmlFor="dosage">Dosage</label>
                  <input
                    type="text"
                    name="dosage"
                    id="dosage"
                    required
                    defaultValue={state?.dosage ?? ""}
                    placeholder="Dosage ou aucun s'il y en a pas.."
                    className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                       border-[#9d9d9d]
                  `}
                  />
                </div>
                <div className="w-full mt-2 flex flex-col gap-1">
                  <label htmlFor="conditionnement">Conditionnement</label>
                  <input
                    type="text"
                    name="conditionnement"
                    id="conditionnement"
                    required
                    defaultValue={state?.conditionnement ?? ""}
                    placeholder="Conditionnement"
                    className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                       border-[#9d9d9d]
                  `}
                  />
                </div>
              </div>
              <div className="w-full text-sm mt-2 flex flex-col gap-1 md:text-base ">
                <label htmlFor="form">Forme</label>
                <input
                  type="text"
                  name="form"
                  id="form"
                  required
                  defaultValue={artico?.forme ?? ""}
                  placeholder="Indiquer la forme"
                  className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                       border-[#9d9d9d]
                  `}
                />
              </div>
              <div className="w-full text-sm mt-2 flex flex-col gap-1  md:text-base ">
                <label htmlFor="structure">Structure</label>
                <input
                  type="text"
                  name="structure"
                  id="structure"
                  required
                  defaultValue={lastCartItem?.structure ?? ""}
                  placeholder="Nom de la structure"
                  className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                     ${
                       state?.errors && state?.errors?.structure
                         ? "border-red-500"
                         : "border-[#9d9d9d]"
                     }  
                  `}
                />
                {state?.errors && state?.errors?.structure && (
                  <p className="text-sm text-red-500 ">
                    {state?.errors?.structure[0]}
                  </p>
                )}
              </div>
              <div className="w-full text-sm mt-2 flex flex-col gap-1  md:text-base  ">
                <label htmlFor="tel">Telephone</label>
                <input
                  type="text"
                  name="tel"
                  id="tel"
                  required
                  defaultValue={lastCartItem?.tel ?? ""}
                  placeholder="Telephone"
                  className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                     ${
                       state?.errors && state?.errors?.tel
                         ? "border-red-500"
                         : "border-[#9d9d9d]"
                     }  
                  `}
                />
                {state?.errors && state?.errors?.tel && (
                  <p className="text-sm text-red-500 ">
                    {state?.errors?.tel[0]}
                  </p>
                )}
              </div>

              <div className="w-full text-sm mt-2 flex flex-col gap-1  md:text-base ">
                <label htmlFor="qt">Email</label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  required
                  placeholder="Email"
                  defaultValue={lastCartItem?.email ?? ""}
                  className={`w-full  border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                     ${
                       state?.errors && state?.errors?.email
                         ? "border-red-500"
                         : "border-[#9d9d9d]"
                     }  
                  `}
                />
                {state?.errors && state?.errors?.email && (
                  <p className="text-sm text-red-500 ">
                    {state?.errors?.email[0]}
                  </p>
                )}
              </div>
              <div className="w-full text-sm mt-2 flex flex-col gap-1  md:text-base ">
                <label htmlFor="adress">Adress</label>
                <textarea
                  name="adress"
                  id="adress"
                  required
                  placeholder="Adress"
                  defaultValue={lastCartItem?.adress ?? ""}
                  className={`w-full resize-none border rounded-sm p-2 focus:outline-none focus:border-[#009900] transition-colors duration-300 
                     ${
                       state?.errors && state?.errors?.adress
                         ? "border-red-500"
                         : "border-[#9d9d9d]"
                     }  
                  `}
                />
                {state?.errors && state?.errors?.adress && (
                  <p className="text-sm text-red-500 ">
                    {state?.errors?.adress[0]}
                  </p>
                )}
              </div>

              <div className="hidden">
                <input
                  type="text"
                  name="articleId"
                  id="articleId"
                  hidden
                  defaultValue={artico?._id.toString()}
                />
                <input
                  type="text"
                  name="price"
                  id="price"
                  hidden
                  defaultValue={artico?.prix_base_ttc}
                />
              </div>

              <div className="w-full flex items-center gap-2 pt-2 ">
                <input
                  type="checkbox"
                  name="check"
                  id="check"
                  checked={validCheck}
                  onChange={(e) => setValidCheck(e.target.checked)}
                />
                <label htmlFor="check" className="text-[#009900] text-sm ">
                  Rassurez-vous d'avoir entrer un email valide pour etre
                  recontacter
                </label>
              </div>

              <div
                className="pt-4
              "
              >
                <button
                  disabled={!validCheck}
                  type="submit"
                  className="text-white flex items-center justify-center gap-4 font-medium w-full py-1.5 rounded-full bg-[#009900] disabled:bg-gray-400 transition-all duration-300 hover:bg-[#005900] "
                >
                  <span>
                    {" "}
                    {isPending
                      ? "Entain d'ajouter..."
                      : "Ajouter dans la list de commande"}{" "}
                  </span>
                  <FaNotesMedical className="text-2xl" />
                </button>
              </div>
            </form>
          </div>

          {/* cancel btn */}
          <MdCancel
            onClick={() => {
              setModalCmd(false);
            }}
            className="absolute top-2 right-4 transition-all duration-300 text-3xl text-white hover:opacity-40 "
          />
        </div>
      </div>

      <div className="w-[14vw] hidden lg:block " />
      <div className=" z-20  fixed left-[2vw]  ">
        <div className="hidden sticky top-10 w-[16vw] rounded-md min-h-[50vh] bg-[#01578C] lg:block ">
          <div className="text-white text-xl font-semibold p-4 border-b border-white/20 ">
            Categories
          </div>
          <div className="flex flex-col gap-2 p-4 max-h-[70vh] overflow-y-auto ">
            {listLoading ? (
              <div className="w-full p-4 flex flex-col gap-2">
                <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
              </div>
            ) : (
              <div className="flex flex-col gap-1">
                <button
                  className={`px-3 py-1 font-semibold rounded ${selectedCategory === "all" ? "bg-blue-500 text-white" : "bg-white"}`}
                  onClick={() => setSelectedCategory("all")}
                >
                  All
                </button>
                {categories?.length > 0 &&
                  categories.map((cat) => (
                    <button
                      key={cat._id}
                      onClick={() => setSelectedCategory(cat.slug)}
                      className={` ${
                        selectedCategory === cat.slug
                          ? "bg-blue-500 text-white"
                          : "bg-white"
                      } text-sm font-semibold text-[#111] px-4 py-1 rounded-sm shadow-sm shadow-[#009900]/10 cursor-pointer transition-all duration-300 hover:opacity-50`}
                    >
                      {cat?.name}
                    </button>
                  ))}
              </div>
            )}

            {!listLoading && categories.length == 0 && (
              <div className="text-xl text-white">
                <h3>Went wrong.. retrying...! </h3>
                <p>
                  Trying to fetch categories list but seems to find a network
                  error
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {listLoading ? (
        <ListMedSchema />
      ) : (
        <div className="flex flex-col h-[80vh] overflow-scroll items-start  gap-4 w-full  pb-4 ">
            {/* //? SEACHE BOX */}
            <div className="flex items-center bg-white w-full sticky top-0 z-30 ">
              <div
                className={`  sticky top-10 z-30 rounded-l-sm flex  items-center  w-full   p-2 transition-all duration-300  `}
              >
                <div className="w-auto rounded-md  flex gap-1 items-center md:w-[70vw] lg:w-[50vw] ">
                  <input
                    type="text"
                    placeholder="Chercher un medicamant.."
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-[80%] pl-10 border border-green-main text-black rounded-sm p-2 focus:outline-none focus:border-blue-main transition-colors duration-300"
                  />
                  <BiSearch className="absolute left-4 text-xl text-gray-500 " />
                </div>
                <IoFilterSharp
                  onClick={() => setShowCatMobile(!showCatMobile)}
                  className="text-xl text-[#009900] z-40  lg:hidden "
                />
                {/* //? CATEGORIES */}
                <div
                  onClick={(e) => {
                    if (e.target == e.currentTarget) setShowCatMobile(false);
                  }}
                  className={` transition-all duration-300 backdrop-blur-[2px]  flex items-center justify-center z-30 fixed top-0 left-0 h-screen w-full bg-[#111]/30 ${
                    showCatMobile
                      ? " pointer-events-auto opacity-100  "
                      : " opacity-0 pointer-events-none  "
                  } lg:hidden `}
                >
                  <div
                    className={`transition-all duration-300   ${showCatMobile ? "translate-x-0 opacity-100 " : " translate-x-full opacity-0 "} ml-auto  w-[70vw] h-screen bg-[#01578C] pt-16 py-6 px-2 rounded-l-md `}
                  >
                    {/* <ListMobileCategories
                  listLoading={listLoading}
                  categories={categories}
                  handleCategoryFilter={handleCategoryFilter}
                /> */}
                    <div className="  w-[75vw] rounded-md min-h-[50vh] bg-[#01578C]  ">
                      <div className="text-white text-xl font-semibold p-4 border-b border-white/20 ">
                        Categories
                      </div>
                      <div className="flex flex-col gap-2 p-4 max-h-[70vh] overflow-y-auto ">
                        {listLoading ? (
                          <div className="w-full p-4 flex flex-col gap-2">
                            <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                            <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                            <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                            <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
                          </div>
                        ) : (
                          <div className="flex flex-col gap-1">
                            <button
                              className={`px-3 py-1 font-semibold rounded ${selectedCategory === "all" ? "bg-blue-500 text-white" : "bg-white"}`}
                              onClick={() => {
                                setSelectedCategory("all");
                                setShowCatMobile(false);
                              }}
                            >
                              All
                            </button>
                            {categories?.length > 0 &&
                              categories.map((cat) => (
                                <button
                                  key={cat._id}
                                  onClick={() => {
                                    setSelectedCategory(cat.slug);
                                    setShowCatMobile(false);
                                  }}
                                  className={` ${
                                    selectedCategory === cat.slug
                                      ? "bg-blue-500 text-white"
                                      : "bg-white"
                                  } text-sm font-semibold text-[#111] px-4 py-1 rounded-sm shadow-sm shadow-[#009900]/10 cursor-pointer transition-all duration-300 hover:opacity-50`}
                                >
                                  {cat?.name}
                                </button>
                              ))}
                          </div>
                        )}

                        {!listLoading && categories.length == 0 && (
                          <div className="text-xl text-white">
                            <h3>Went wrong.. retrying...! </h3>
                            <p>
                              Trying to fetch categories list but seems to find
                              a network error
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div
                onClick={() => setSeeSearch(!seeSearch)}
                className="bg-green-main shadow-2xl z-30 cursor-pointer shadow-green-main fixed bottom-20 left-18  text-white h-8 w-8 flex justify-center items-center rounded-sm"
              >
                { seeSearch? <IoCloseCircle className="text-4xl " /> :  <BiSearch className="text-2xl " />}
               
              </div> */}
            </div>
          {/* //? LIST && RECHERCHE */}
          <div className="  relative bg-orange-30 flex flex-col gap-2  w-full   ">
          
            {/* //? LIST */}
            <div>
              {/* <div className="grid grid-cols-1 gap-2" >
                  <div className="grid grid-cols-6 gap-2 text-white text-xl p-2 bg-green-main" >
                    <p className=" font-semibold ">Eticket</p>
                    <p className=" font-semibold text-center">Code</p>
                    <p className=" font-semibold text-center">Libelé</p>
                    <p className=" font-semibold text-center">Type</p>
                    <p className=" font-semibold text-center">Prix</p>
                    <p className=" font-semibold text-center ">Action</p>
                  </div>
                  
              </div> */}
             <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6">
              {filteredArticles?.map((art) => (
                <div
                  key={art?._id.toString()}
                  className="border-t py-2 border-gray-500 pr-2 "
                >
                  <div className="rounded-sm overflow-hidden h-full bg-[#009900]/5 flex flex-col gap-y-1 ">
                    <div className="flex-[0.5] flex items-center gap-2  ">
                      <div className=" bg-[#009900] p-1 flex justify-center items-center w-10 h-10  text-white ">
                        {art?.theCode === "DORA" && (
                          <MyImage imgPath="/assets/med/pills.png" alt="" />
                        )}
                        {art?.theCode === "DINJ" && (
                          <MyImage imgPath="/assets/med/inj.png" alt="" />
                        )}
                      </div>
                      <h1 className="text-xs font-bold text-[#111] flex items-center flex-wrap gap-2 ">
                        {art?.categoryId?.name}
                        <span className="font-light"> |</span>
                        <span className="font-light"> {art?.type}</span>
                      </h1>
                    </div>
                    <div className="flex  flex-[3] px-2  justify-between flex-col w-full   ">
                      <p className="text-[#111]  text-sm lg:text-lg ">{art.libele}</p>
                      <div className="flex w-full gap-6  justify-between items-end py-1    ">
                        {+art.prix_base_ttc > 0 ? (
                          <span className="w-full flex items-center justify-start gap-1 ">
                            <span className="text-base text-[#009900] ">$</span>{" "}
                            <span className="font-bold">
                              {art.prix_base_ttc}
                            </span>
                          </span>
                        ) : (
                          <span className="w-full flex items-center justify-start gap-1 ">
                            <span className="text-base text-[#009900] ">$</span>{" "}
                            <span className="font-bold text-gray-500 ">0</span>
                          </span>
                        )}

                        <div
                          onClick={() => handleComdClick(art)}
                          className="flex gap-1 bg-[#edf04f]  text-[#009900] py-1 px-3 rounded-sm items-center justify-between transition-all duration-300 hover:text-white hover:cursor-pointer hover:bg-[#111] "
                        >
                          <GiHandTruck className="text-4xl" />
                          {/* <p className="text-xs">Ajouter</p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            </div>
           
          </div>
        </div>
      )}

      {!listLoading && articleList.length == 0 && (
        <div className="h-[50vh] w-full flex flex-col items-center gap-4 bg-[#009900]/5 rounded-md ">
          <div className="h-[40vh] w-[40vh] ">
            <MyImage imgPath="/assets/svg/emptyBox1.svg" alt="" />
          </div>
          <p className="text-[#111] text-lg ">
            Something went wrong! it may be Network issue, Retry later please!
          </p>
        </div>
      )}
    </div>
  );
}




function ListMobileCategories({
  listLoading,
  categories,
  handleCategoryFilter,
}: {
  listLoading: boolean;
  categories: categoryType[];
  handleCategoryFilter: (cat: categoryType) => void;
}) {
  return (
    <div className="flex flex-col gap-2 pt-[7vh] max-h-[70vh] overflow-y-auto ">
      {listLoading ? (
        <div className="w-full p-4 flex flex-col gap-2">
          <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
          <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
          <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
          <div className="w-full h-4 rounded-md bg-white/30 animate-pulse  " />
        </div>
      ) : (
        <div className="bg-white text-[#111] text-sm px-2 py-1 rounded-sm shadow-sm shadow-[#009900]/10 ">
          Tout voir
        </div>
      )}{" "}
      {categories?.length > 0 &&
        categories.map((cat) => (
          <div
            key={cat._id}
            onClick={() => handleCategoryFilter(cat)}
            className="bg-white/70 text-[#111] text-sm px-2 py-1 rounded-sm shadow-sm shadow-[#009900]/10 transition-all duration-300 hover:bg-white hover:scale-101 cursor-pointer "
          >
            {cat.name}
          </div>
        ))}
      {!listLoading && categories.length == 0 && (
        <div className="text-xl text-white">
          <h3>Went wrong.. retrying...! </h3>
          <p>
            Trying to fetch categories list but seems to find a network error
          </p>
        </div>
      )}
    </div>
  );
}
